/* Dusk-to-night: writes the current hour onto <html> as sections pass the
   viewport midpoint. The server already rendered a sane default hour, so
   this file only ever refines what is on screen. ~1 KB, no dependencies. */
(function () {
  'use strict';
  var root = document.documentElement;

  // layout/artifact.liquid ships <html class="no-js"> and never removes it
  // (unlike layout/theme.liquid, which does this inline in <head>). Placed
  // above the early-return below on purpose: removing no-js must not depend
  // on this page happening to have section[data-hour] elements.
  root.classList.remove('no-js');

  /* The hero used to ship with `in` hardcoded beside `rise`, so opacity 0 and 1
     both applied at parse and it never animated. Add `in` on the frame after
     paint so the transition has a state change to run. Also placed above the
     early-return below so it runs on any page carrying a `.hero`, independent
     of the hour-drift feature's own precondition. */
  var hero = document.querySelectorAll('.hero .rise');
  if (hero.length) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        for (var h = 0; h < hero.length; h++) hero[h].classList.add('in');
      });
    });
  }

  // Scoped to `section` on purpose: <html> also carries data-hour (the
  // server-rendered default), and an unscoped selector observes it too. <html>
  // spans the whole document, so it intersects the midline permanently.
  var sections = document.querySelectorAll('section[data-hour]');
  if (!sections.length || !('IntersectionObserver' in window)) return;

  function apply(hour) {
    if (root.dataset.hour !== hour) root.dataset.hour = hour;
  }

  var observer = new IntersectionObserver(function (entries) {
    // NOT "at most one section intersects at a time" — that is false, batches of
    // four intersecting entries have been observed (a fast scroll or a wheel jump
    // crosses several midlines before the callback runs, and the observer reports
    // them together). The real invariant is the one this loop depends on:
    // IntersectionObserver delivers entries in the order the changes were
    // observed, so the LAST intersecting entry in the batch is the most recent
    // crossing and therefore the hour the reader has actually landed on.
    for (var i = entries.length - 1; i >= 0; i--) {
      if (entries[i].isIntersecting) {
        apply(entries[i].target.getAttribute('data-hour'));
        return;
      }
    }
  }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });

  for (var i = 0; i < sections.length; i++) observer.observe(sections[i]);
})();
